import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { ConfirmCompleteTasksDialogComponent } from './confirm-complete-tasks-dialog-component';
import { CompleteTasksRequest } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { usePostToTab } from '../../../../areas/search/hooks/usePostToTab';
import { TASK_CLOSED } from '../../../../areas/search/dashboard/components/dashboard-worklist-component/task-closed';

export interface IConfirmCompleteTasksDialogProps {
  taskIds: string[];
  onCompleted?: () => void;
}

export function ConfirmCompleteTasksDialog({ taskIds, onCompleted }: IConfirmCompleteTasksDialogProps) {
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const postTaskClosed = usePostToTab<string[]>(TASK_CLOSED);

  const handleConfirm = async () => {
    const request: CompleteTasksRequest = {
      taskIds,
    };
    try {
      await moduleClientFactory.createJobcenterTaskClient().completeTasks(request);
      postTaskClosed(window, taskIds);

      enqueueSnackbar('Alle opgaver blev afsluttet', { variant: 'success' });
      onCompleted?.();
    } catch (_) {
      enqueueSnackbar('Ikke alle opgaver blev afsluttet', { variant: 'error' });
    }
    setIsOpen(false);
  };
  function handleClose() {
    setIsOpen(false);
  }
  return <ConfirmCompleteTasksDialogComponent open={isOpen} tasksCount={taskIds.length} onCancelClick={handleClose} onConfirmClick={handleConfirm} />;
}
